import React from "react";

import { Box } from "@chakra-ui/react";
import { BusinessContentItem } from "features/business-compliance/selected-business/BusinessContentItem";
import { IBusinessContentItem } from "features/business-compliance/selected-business/types";
import { ComplianceStatus } from "features/individual-compliance/selected-individual/ComplianceStatus";
import { capitalizeFirstLetter } from "utils";
import { START_INDEX } from "utils/constants";

import { Paragraph4 } from "ui/typography";

import { IBusinessDetailsKYBVerificationResultsProps } from "./types";

const INDEX_OFFSET = 1;
export const BusinessDetailsKYBVerificationResults = (
  props: IBusinessDetailsKYBVerificationResultsProps
) => {
  const { isContentWrapperBelow600, isContentWrapperBelow745, data } = props;

  const verificationResults: IBusinessContentItem[] = [
    {
      title: "Verification Provider",
      content: "Prembly",
    },
    {
      title: "Company Type",
      content: data?.companyType?.toUpperCase() || "-",
    },
    {
      title: "Address",
      content: data?.companyAddress || "-",
    },
    {
      title: "Business Status",
      content: (
        <ComplianceStatus
          status={`${data?.companyStatus?.toLowerCase() === "active" ? "approved" : "rejected"}`}
          text={capitalizeFirstLetter(data?.companyStatus || "-")}
          className="w-fit"
        />
      ),
    },
  ];

  const directors: IBusinessContentItem[][] = (data?.directors || []).map(
    (director) => [
      {
        title: "Name",
        content: `${director?.surname} ${director?.firstname}`,
      },
      {
        title: "Shareholding",
        content: director?.numSharesAlloted || "-",
      },
      {
        title: "ID Type",
        content: director?.formType || "-",
      },
      {
        title: "ID Number",
        content: director?.identityNumber || "-",
      },
      {
        title: "Address",
        content: `${director?.streetNumber} ${director?.address} ${director?.state}`,
      },
      {
        title: "Nationality",
        content: director?.nationality || "-",
      },
    ]
  );

  return (
    <Box className="flex flex-col gap-6">
      <Box>
        <Paragraph4
          fontWeight="700"
          lineHeight="24px"
          textColor="#374151"
          className="mb-4"
        >
          VERIFICATION RESULTS
        </Paragraph4>
        <Box
          css={{
            display: "flex",
            flexWrap: "wrap",
            columnGap: "32px",
            rowGap: "16px",
          }}
        >
          {verificationResults.map((verificatioResult, index) => (
            <BusinessContentItem
              key={index}
              title={verificatioResult.title}
              content={verificatioResult.content}
              isContentWrapperBelow745={isContentWrapperBelow745}
              isContentWrapperBelow600={isContentWrapperBelow600}
            />
          ))}
        </Box>
      </Box>
      <Box>
        <Paragraph4
          fontWeight="700"
          lineHeight="24px"
          textColor="#374151"
        >
          DIRECTORS
        </Paragraph4>
        {directors.length > START_INDEX ? (
          directors.map((directorX, index) => (
            <React.Fragment key={index}>
              <Paragraph4
                fontWeight="700"
                lineHeight="24px"
                textColor="#374151"
                className="mb-1 mt-4"
              >
                DIRECTOR {index + INDEX_OFFSET}
              </Paragraph4>
              <Box
                css={{
                  display: "flex",
                  flexWrap: "wrap",
                  columnGap: "32px",
                  rowGap: "16px",
                }}
              >
                {directorX.map((director, index) => (
                  <BusinessContentItem
                    key={index}
                    title={director.title}
                    content={director.content}
                    isContentWrapperBelow745={isContentWrapperBelow745}
                    isContentWrapperBelow600={isContentWrapperBelow600}
                  />
                ))}
              </Box>
            </React.Fragment>
          ))
        ) : (
          <Paragraph4
            lineHeight="24px"
            textColor="#374151"
          >
            NO DIRECTORS
          </Paragraph4>
        )}
      </Box>
    </Box>
  );
};
